import {
  IonContent,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonMenu,
  IonMenuToggle,
  IonButton
} from '@ionic/react';

import { menuController } from '@ionic/core/components';
import React, { useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { close, informationCircleOutline, informationCircleSharp, homeOutline, homeSharp, settingsOutline, settingsSharp, exitOutline, exitSharp } from 'ionicons/icons';
import ServerService from '../services/Server';
import './Menu.css';

interface AppPage {
  url: string;
  iosIcon: string;
  mdIcon: string;
  title: string;
}

const appPages: AppPage[] = [
  {
    title: 'Main',
    url: '/page/home',
    iosIcon: homeOutline,
    mdIcon: homeSharp
  },
  {
    title: 'Settings',
    url: '/page/settings',
    iosIcon: settingsOutline,
    mdIcon: settingsSharp
  },
  // {
  //   title: 'Test',
  //   url: '/page/test',
  //   iosIcon: qrCodeOutline,
  //   mdIcon: qrCodeSharp
  // },
  {
    title: 'About',
    url: '/page/about',
    iosIcon: informationCircleOutline,
    mdIcon: informationCircleSharp
  },
  {
    title: 'Log Out',
    url: '/page/logout',
    iosIcon: exitOutline,
    mdIcon: exitSharp
  }
];

const Menu: React.FC = () => {
  const location = useLocation();
  const pathname:string = window.location.pathname;
  const history = useHistory();
  const [menuEn, setMenuEn] = useState<boolean>(false);
  const { isAuthenticated } = useAuth();
  const server = new ServerService();

  if (server.state.pin=="1" && !isAuthenticated) return null;

  return (
    <IonMenu contentId="main" type="overlay" menuId="mainmenu">
      <IonContent>
        <IonList id="inbox-list">
          <IonListHeader>Menu
          {menuEn ? (
            <IonButton onClick={async () => {await menuController.enable(false,"mainmenu");history.push(pathname);}}>
            <IonIcon icon={close}/>
            </IonButton>
          ) : (
            <div/>
          )}
          </IonListHeader>
          {appPages.map((appPage, index) => {
            return ((index!=3 || server.state.logout=="1") ? (
              <IonMenuToggle key={index} autoHide={false}>
                <IonItem className={location.pathname === appPage.url ? 'selected' : ''} routerLink={appPage.url} routerDirection="none" lines="none" detail={false}>
                  <IonIcon slot="start" ios={appPage.iosIcon} md={appPage.mdIcon} />
                  <IonLabel>{appPage.title}</IonLabel>
                </IonItem>
              </IonMenuToggle>
            ) : null);
          })}
        </IonList>
      </IonContent>
    </IonMenu>
  );
};

export default Menu;
